import { styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Typography } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { Link } from "react-router-dom";

export const DangerContainer = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  backgroundColor: "#FEEAEA",
  color: "#DC3545",
  border: "1px solid #DC3545",
  borderRadius: "8px",
  width: "100%",
  padding: "12px",
}));

export const ErrorContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const ErrorTextContainer = styled("div")(() => ({
  padding: "12px 12px 12px 0px",
  gap: "4px",
  flex: "1 0 0",
}));

export const ErrorIconContainer = styled("div")(() => ({
  display: "flex",
  padding: "12px",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
}));

export const ErrorIcon = styled("img")(() => ({
  width: "20px",
  height: "20px",
  flexShrink: 0, // Prevents the image from shrinking
}));

export const ErrorText = styled(Typography)(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: "#DC3545",
  fontWeight: 400,
  "& strong": {
    fontWeight: 700,
  },
}));

export const UnitSymbolText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  textAlign: "left",
  letterSpacing: "0.10000000149011612px",
}));

export const SecondsCounterText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "22px",
  fontWeight: 700,
  lineHeight: "28px",
  textAlign: "left",
}));

interface HiddenTextProps {
  hide?: boolean;
}

export const HiddenText = styled("span")(({ hide }: HiddenTextProps) => ({
  ...(hide ? { display: "none" } : {}),
}));

export const ForgotLink = styled(Link)(() => ({
  textDecoration: "underline",
}));

export const TimerContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "2px",
  alignSelf: "stretch",
  borderLeft: `1px solid ${colors.error200}`,
  width: "92px",
}));

export const ErrorTextForCounter = styled(Typography)(() => ({
  fontFamily: "Manrope",
  minWidth: "50px",
  "&:last-of-type": {
    fontSize: "22px",
    lineHeight: "28px",
    letterSpacing: "0.25px",
    color: colors.error700,
    fontWeight: 700,
  },
}));

export const StyledImage = styled("img")(() => ({
  width: "16px",
  height: "16px",
  display: "block",
  cursor: "pointer",
  "@media (max-width: 600px)": {
    width: "14px",
    height: "14px",
  },
}));

interface HiddenTextProps {
  hide?: boolean;
}

const styles = makeStyles(() => ({
  mainGrid: {
    width: "100%",
    maxWidth: "520px",
    alignItems: "flex-start",
  },
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    color: "#1D2939",
    fontSize: "24px",
    lineHeight: "32px",
    marginBottom: "0px",
    marginTop: "0px",
  },
  text: {
    fontFamily: "Manrope",
    color: "#667085",
    fontSize: "14px",
    lineHeight: "20px",
  },
  accountLoggedInText: {
    color: colors.error600,
    fontFamily: "Manrope",
    fontSize: "14px",
    marginLeft: "7%",
    lineHeight: "50px",
  },
  boxContainer: {
    width: "100%",
    maxWidth: "520px",
    alignSelf: "flex-start",
    color: "#1D2939",
    fontSize: "14px",
  },
  clickableText: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    color: "#0055A4",
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  createAccount: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
  },
}));

export default styles;
